import { render, staticRenderFns } from "./watch.vue?vue&type=template&id=3f992d78&"
import script from "./watch.vue?vue&type=script&lang=js&"
export * from "./watch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports